import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { HelperService } from 'src/app/services/helper/helper.service';

@Component({
  selector: 'flight-list-card',
  templateUrl: './flight-list-card.component.html',
  styleUrls: ['./flight-list-card.component.scss'],
})
export class FlightListCardComponent implements OnInit {
  @Input() flight: any;

  constructor(private helperService: HelperService, private navControl: NavController, private analyticsService: AnalyticsService ) { }

  ngOnInit() {}

  navigateToDetail(flight: any) {
    this.analyticsService.trackUnified('flight_card_details_clicked', {
      flow: 'flight',
      outcome: 'success',
      legacy_event_name: 'clicked_flight_card_details',
      component: 'flight-list-card-component',
      button: 'navigate-to-detail-button',
      flight_id: flight.flight_id,
    });
    let legNo = this.helperService.generateLegNo(
      flight.flight_id,
      flight.scheduled_departure,
      flight.origin,
      flight.dest
    );
    this.navControl.navigateForward(['flight/', legNo]);
  }

}
